import { useTranslation } from 'react-i18next';

import type { DiagramSeriesOption } from '@/features/time-series-chart/types/DiagramSeries.types';

import { DiagramSeriesChips } from '../diagram-series-chips/DiagramSeriesChips';
import { NavigationHint, NavigationHintText, ToolbarContent, ToolbarRoot } from './TimeSeriesChartToolbar.style';

export type TimeSeriesChartToolbarProps = {
  selectedSeries: DiagramSeriesOption[];
  highlightedSeriesIds: string[];
  getSeriesColor: (seriesId: string) => string;
  onHighlightToggle: (seriesId: string) => void;
  onDeselect: (seriesId: string) => void;
  isNavigationHintVisible: boolean;
};

/** The row above the chart: a chip per selected series, and the zoom/pan hint while a chart is shown. */
export function TimeSeriesChartToolbar({
  selectedSeries,
  highlightedSeriesIds,
  getSeriesColor,
  onHighlightToggle,
  onDeselect,
  isNavigationHintVisible,
}: TimeSeriesChartToolbarProps) {
  const { t } = useTranslation();

  if (selectedSeries.length === 0 && !isNavigationHintVisible) {
    return null;
  }

  return (
    <ToolbarRoot data-qa-element-id="time-series-chart-toolbar">
      <ToolbarContent>
        <DiagramSeriesChips
          series={selectedSeries}
          highlightedSeriesIds={highlightedSeriesIds}
          getSeriesColor={getSeriesColor}
          onHighlightToggle={onHighlightToggle}
          onDeselect={onDeselect}
        />
      </ToolbarContent>
      {isNavigationHintVisible && (
        <NavigationHint elevation={3} role="note" data-qa-element-id="time-series-chart-navigation-hint">
          <NavigationHintText variant="caption" color="text.disabled">
            {t('timeSeriesChart.chart.navigationHint')}
          </NavigationHintText>
        </NavigationHint>
      )}
    </ToolbarRoot>
  );
}
